/* eslint-disable import/no-cycle */
import { useContext, useEffect, useState } from 'react';
import { FormikHelpers } from 'formik';
import AuthContext from '../../AppContext/AuthProvider';
import { TMessagingBlade } from '../../models/Message/@types';
import SkillbuilderModel from '../../models/SkillBuilder';
import { logger } from '../../utils';
import useAsyncTask from '../../hooks/useAsyncTask';
import { getMessageData } from '../../models/Message/api';
import { SkillBuilderSubmissionFormData } from '../SkillbuilderSubmissionForm';
import { SKILLBUILDER_ERRORS } from '../../Constants/ErrorMessages';

function useSkillBuilderActions(skillBuilderId: string) {
  const { appUser } = useContext(AuthContext);

  const skillBuilderParticipationCheck = async () => {
    try {
      const { data } = await SkillbuilderModel.hasUserAlreadyParticipated(skillBuilderId);
      setHasParticipated(data);
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    getModalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (appUser) skillBuilderParticipationCheck();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUser]);

  const [modalData, setModalData] = useState<TMessagingBlade>();

  const [hasParticipated, setHasParticipated] = useState(false);
  const getModalData = async () => {
    try {
      const submissionSuccess = await getMessageData(['Got Your Submission']);

      setModalData(submissionSuccess['Got Your Submission']);
    } catch (error) {
      logger.error(error);
    }
  };

  const handleCreateSkillbuilderSubmission = useAsyncTask<{
    values: SkillBuilderSubmissionFormData;
    formikHelpers: FormikHelpers<SkillBuilderSubmissionFormData>;
  }>(async data => {
    const { values, formikHelpers } = data;
    const { submission, score } = values;
    if (!skillBuilderId) return;
    try {
      await SkillbuilderModel.createSkillbuilderSubmission(skillBuilderId, submission, score);
    } catch (error) {
      formikHelpers.setErrors({
        submission: SKILLBUILDER_ERRORS.SKILLBUILDER_SUBMISSION_REQUIRED,
      });
      logger.error(error);
    }
  });

  const handleSubmissionDone = async () => {};

  return {
    modalData,
    hasParticipated,
    handleSubmissionDone,
    handleCreateSkillbuilderSubmission,
    setHasParticipated,
  };
}

export default useSkillBuilderActions;
